import React from "react";
import { Card } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import "./Expenses.scss"; // Ensure this file exists for styling

const Expenses = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div
        className="shadow-lg rounded-2xl p-6 text-center card-container"
        style={{
          height: "400px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <ClockCircleOutlined
          style={{ fontSize: "48px", color: "#1890ff", marginBottom: "16px" }}
        />
        <h2 className="text-xl font-semibold mb-2">Expenses</h2>
        <p className="text-gray-500">This feature is under development.</p>
        <p className="text-gray-400 mt-1 text-sm">Coming Soon 🚀</p>
      </div>
    </div>
  );
};

export default Expenses;
